import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M13.29 15.833h.84q.199 0 .2.2v.654q-.001.2-.2.2h-3.174q-.2 0-.2-.2v-.654q0-.2.2-.2h.84V11.38h-.72q-.2 0-.2-.2v-.693q0-.2.2-.2h2.013q.2 0 .2.2zM11.675 9.1a.95.95 0 0 1-.253-.68q0-.413.253-.68a.9.9 0 0 1 .693-.28q.44 0 .694.28a.92.92 0 0 1 .266.68.92.92 0 0 1-.266.68q-.267.267-.707.267-.427 0-.68-.267" fill="#243E81"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.543 20.673a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m0 1.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10" fill="#243E81"/>' }
  })
);